import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { CHARGEBACKS_ROUTE_PATHS } from './config';

export const CHARGEBACKS_ROUTES: TApplicationRoute[] = [
  {
    id: 'chargebacks',
    path: CHARGEBACKS_ROUTE_PATHS.chargebacks,
    component: lazy(() => import('./pages/chargebacks-page')),
    layout: 'default',
    permissions: { scopes: ['chargebacks'] },
    menu: {
      title: 'pages.fraud.chargebacks.title',
    },
  },
];
